module.exports = __webpack_public_path__ + "media/images/icon/trash-98d20546c4a524823b12ab57548c819b.svg";